import clsx from "clsx";
import styles from "./ShellTopbar.module.scss";

export interface ShellTopbarProps {
  /** The bar's row, left to right: the shell's own brand lockup, an optional `ShellNav`, `ShellTopbarActions`. */
  children: React.ReactNode;
  className?: string;
}

/**
 * The app's sticky frosted top bar, shared by every shell that paints one.
 *
 * It owns the CHROME and nothing else — the height (one token, so the bar does not shift under you when you
 * cross between an artist and the roster view of that same artist), the frosted-white ground, the hairline,
 * and the full-bleed inner row that weights its first child hard left and {@link ShellTopbarActions} hard
 * right. What goes IN it stays with each shell: the artist stacks a wordmark over "Welcome back, …", the
 * roster carries the org lockup, the partner viewer just a mark.
 */
export function ShellTopbar({ children, className }: ShellTopbarProps) {
  return (
    <header className={clsx(styles.topbar, className)}>
      <div className={styles.topbarInner}>{children}</div>
    </header>
  );
}

export interface ShellTopbarActionsProps {
  children: React.ReactNode;
  className?: string;
}

/** The bar's trailing cluster — weighted to the far right whether or not the shell has a nav. */
export function ShellTopbarActions({ children, className }: ShellTopbarActionsProps) {
  return <div className={clsx(styles.actions, className)}>{children}</div>;
}
